/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_TitleInputs */

const en_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue List`)
};

const fr_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des dialogues`)
};

const de_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogliste`)
};

const it_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco dialoghi`)
};

const ru_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список диалогов`)
};

const es_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de diálogos`)
};

const zh_cn2_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话列表`)
};

const ja_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話リスト`)
};

const hi_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद सूची`)
};

const pt_pt2_file_export_dialogue_list_title = /** @type {(inputs: File_Export_Dialogue_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de diálogos`)
};

/**
* | output |
* | --- |
* | "Dialogue List" |
*
* @param {File_Export_Dialogue_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_title = /** @type {((inputs?: File_Export_Dialogue_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_dialogue_list_title(inputs)
	if (locale === "de") return de_file_export_dialogue_list_title(inputs)
	if (locale === "it") return it_file_export_dialogue_list_title(inputs)
	if (locale === "ru") return ru_file_export_dialogue_list_title(inputs)
	if (locale === "es") return es_file_export_dialogue_list_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_dialogue_list_title(inputs)
	if (locale === "ja") return ja_file_export_dialogue_list_title(inputs)
	if (locale === "hi") return hi_file_export_dialogue_list_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_dialogue_list_title(inputs)
	return en_file_export_dialogue_list_title(inputs)
});